<template>
  <div class="orcamento-info-adicional" id="orcamento-info-adicional">
    <span class="orcamento-info-adicional__icon" aria-hidden="true">
      <i class="fa fa-exclamation"></i>
    </span>
    <span class="orcamento-info-adicional__text">
      Para enviar o pedido, o valor mínimo deve ser de
      <strong>R$ 600,00</strong>, considerando a Quantidade, o Valor Unitário dos
      produtos e a Margem.
    </span>
  </div>
</template>

<script>
export default {
  name: "OrcamentoInformacaoAdicional",
};
</script>

<style scoped>
.orcamento-info-adicional {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid #f0d9a8;
  border-radius: 10px;
  background: #fff8e8;
  color: #8a5a16;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.45;
}

.orcamento-info-adicional__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-top: 0.05rem;
  border-radius: 999px;
  background: #f0b429;
  color: #fff;
  font-size: 0.72rem;
}

.orcamento-info-adicional__text strong {
  color: #c47f0a;
  font-weight: 700;
}
</style>
